import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const columns: ColumnInterface[] = [
  {
    title: 'Код периода',
    key: 'period_code_out',
    width: 250,
    fixedLeft: true,
    orderBy: {
      order: 1,
    },
  },
  {
    title: 'Код месяца подачи отчетности',
    key: 'preparation_month_code_out',
    width: 220,
  },
  {
    title: 'День месяца подачи отчетности',
    key: 'preparation_day',
    width: 220,
  },
  {
    title: 'Месяц раскрытия отчетности',
    key: 'disclosure_month_code_out',
    width: 220,
  },
  {
    title: 'День месяца раскрытия отчетности',
    key: 'due_day',
    width: 220,
  },
  {
    title: 'Периодичность',
    key: 'frequency_code_out',
    width: 220,
  },
  {
    key: 'period_code',
    hidden: true,
  },
  {
    key: 'report_group_code',
    hidden: true,
  },
];
